/* istanbul ignore file */
import React, { useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  TextField,
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Checkbox,
  Collapse,
  RadioGroup,
  Radio,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from '@material-ui/core';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import messages from 'containers/PreOpeningPage/messages';
import { translate, arrayTranslate } from 'containers/services/translate';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { CLAIM } from 'containers/data-structure';
import { find, get, isEmpty } from 'lodash';
import { Listings, Config, SagisConfig } from 'containers/AppContainer/typings';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import ClaimCircumstancesDrawer from 'containers/RecapManagerPage/ClaimCircumstancesDrawer';
import validate from 'containers/services/validateForm';
import { displayErrorText } from 'containers/services/validateForm';
import {
  MANAGEMENT_MODES,
  SCALE_CASES_KEY,
} from 'containers/RecapManagerPage/constants';
import { GridWrapper } from 'containers/PreOpeningPage/ClaimInformation/style';
import { Container } from 'containers/PreOpeningPage/styled-component';
export const claimCircumstancesConstraints = (claim: any) => {
  return {
    [CLAIM.RESPONSABILITY_SHARE]: {
      presence: true,
    },
    [CLAIM.ACCIDENT_DESCRIPTION]: {
      presence: true,
    },
    [CLAIM.IS_JUDICIAL_PROCEDURE]: {
      presence: true,
    },
    [CLAIM.SCALE_CASE_KEY]: {
      presence: true,
    },
    [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: {
      presence: true,
    },
    [CLAIM.RESPONSABILITY_KEY]: {
      presence: true,
    },
    [CLAIM.JUDICIAL_PROCEDURE_ID]: {
      presence: get(claim, [CLAIM.IS_JUDICIAL_PROCEDURE], '') === CHOICE.YES,
    },
  };
};

export const claimCircumstancesValidator = (claim: any) => {
  return validate(claim, claimCircumstancesConstraints(claim));
};

export interface ClaimCircumstancesProps {
  intl: IntlShape;
  updateFilde?: Function;
  claimToPreopen: any;
  inputProps?: any;
  disableInput?: boolean;
  inputLabelProps?: boolean;
  listings?: Listings;
  storedClaimToPreopen?: any;
  setClaimRecap?: Function;
  claimCircumstancesValidation?: any;
  isRecapPage: boolean;
  isManager: boolean;
  isReadOnly: boolean;
}
const ClaimCircumstances: React.FC<ClaimCircumstancesProps> = (
  props,
): JSX.Element => {
  const [isScaleCaseOther, updateIsScaleCaseOther] = useState(false);
  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const getCircumstances = () => {
    let circumstances = get(props.listings, 'circumstance', []).filter(
      (circumstance: SagisConfig) =>
        circumstance.ItemGroup === claim[CLAIM.SCALE_CASE_KEY],
    );
    return circumstances;
  };

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string; value: any }>,
  ) => {
    const { value } = event.target;

    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };

    const { claim } = claimToPreopen;
    switch (field) {
      case CLAIM.IS_JUDICIAL_PROCEDURE:
        claim[CLAIM.IS_JUDICIAL_PROCEDURE] = value;
        break;
      case CLAIM.JUDICIAL_PROCEDURE_ID:
        claim[CLAIM.JUDICIAL_PROCEDURE_ID] = parseInt(value);
        break;

      case CLAIM.SCALE_CASE_KEY:
        claim[CLAIM.ACCIDENT_CIRCONSTANCE_KEY] = '';
        claim[CLAIM.ACCIDENT_CIRCONSTANCE] = '';
        claim[CLAIM.RESPONSABILITY_KEY] = '';
        claim[CLAIM.RESPONSABILITY_SHARE] = '';
        claim[CLAIM.SCALE_CASE_KEY] = value;
        if (value === SCALE_CASES_KEY.OTHER) {
          updateIsScaleCaseOther(true);
        } else {
          updateIsScaleCaseOther(false);
        }
        break;
      case CLAIM.ACCIDENT_CIRCONSTANCE_KEY: {
        claim[CLAIM.ACCIDENT_CIRCONSTANCE] = '';
        claim[CLAIM.RESPONSABILITY_KEY] = '';
        claim[CLAIM.RESPONSABILITY_SHARE] = '';
        claim[CLAIM.ACCIDENT_CIRCONSTANCE_KEY] = value;
        const expectedCircumstance = get(
          props.listings,
          'circumstance',
          [],
        ).find((circumstance: SagisConfig) => circumstance.ItemKey === value);

        claim[CLAIM.RESPONSABILITY_KEY] = expectedCircumstance
          ? expectedCircumstance.responsablityRateCode
          : '';
        if (isScaleCaseOther) {
          claim[CLAIM.ACCIDENT_CIRCONSTANCE] = expectedCircumstance
            ? expectedCircumstance.ItemDescription
            : '';
        }
        const responsability = find(
          get(props.listings, 'responsability'),
          (element: { ItemKey: any }) =>
            element.ItemKey === claim[CLAIM.RESPONSABILITY_KEY],
        );
        claim[CLAIM.RESPONSABILITY_SHARE] = get(
          responsability,
          'ItemDescription',
          '',
        );
        break;
      }

      case CLAIM.RESPONSABILITY_KEY:
        claim[CLAIM.RESPONSABILITY_KEY] = value;
        const responsability = find(
          get(props.listings, 'responsability'),
          (element: { ItemKey: any }) =>
            element.ItemKey === claim[CLAIM.RESPONSABILITY_KEY],
        );
        claim[CLAIM.RESPONSABILITY_SHARE] = get(
          responsability,
          'ItemDescription',
          '',
        );
        break;
      case CLAIM.ACCIDENT_DESCRIPTION:
        claim[CLAIM.ACCIDENT_DESCRIPTION] = value;
        break;
      case CLAIM.MANAGEMENT_MODE:
        claim[CLAIM.MANAGEMENT_MODE] = value;
        break;
      default:
        return claimToPreopen;
    }

    props.updateFilde && props.updateFilde(claimToPreopen);
  };

  let value = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : props.claimToPreopen;

  const { claim } = value;

  const [
    expandClaimCircumstancesDrawer,
    setExpandClaimCircumstancesDrawer,
  ] = React.useState(false);

  const updateFormByProfile = () => {
    if (props.isManager) {
      return setExpandClaimCircumstancesDrawer(!expandClaimCircumstancesDrawer);
    }
    return pushTo(PAGES.PREOPENING)();
  };

  const closeClaimCircumstancesDrawer = () => {
    return setExpandClaimCircumstancesDrawer(false);
  };

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    props.claimCircumstancesValidation,
    translateArrayErrorMessages(props.claimCircumstancesValidation, true),
  );
  return (
    <Container className="container">
      <Card>
        <CardContent>
          <Typography className="title">
            {translate({ ...messages.claimCircumstancesTitle }, props)}
          </Typography>

          <GridWrapper>
            <Grid container direction="row">
              <Grid item xs>
                <FormControl className="input">
                  <InputLabel
                    ref={inputLabel}
                    id="management-mode"
                    className="label"
                  >
                    {translate({ ...messages.managementMode }, props)}
                  </InputLabel>
                  <Select
                    name="management-mode"
                    value={get(claim, [CLAIM.MANAGEMENT_MODE])}
                    onChange={handleChange(CLAIM.MANAGEMENT_MODE)}
                  >
                    {!isEmpty(get(props.listings, 'modeGestion', [])) &&
                      get(props.listings, 'modeGestion', [])
                        .filter(
                          (mode: {
                            ItemKey: string;
                            ItemDescription: string;
                          }) => mode.ItemKey != '2',
                        )
                        .map(
                          (mode: {
                            ItemKey: string;
                            ItemDescription: string;
                          }) => (
                            <MenuItem value={mode.ItemKey} key={mode.ItemKey}>
                              {mode.ItemDescription}
                            </MenuItem>
                          ),
                        )}
                  </Select>
                </FormControl>
              </Grid>
              {(get(claim, [CLAIM.MANAGEMENT_MODE]) ===
                MANAGEMENT_MODES.COMMON_RIGHT ||
                get(claim, [CLAIM.MANAGEMENT_MODE]) ===
                  MANAGEMENT_MODES.FOREIGN) && (
                <Grid container spacing={5}>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <InputLabel
                        ref={inputLabel}
                        id="scaleCase"
                        className="label"
                      >
                        {translate({ ...messages.scaleCase }, props)}
                      </InputLabel>
                      <Select
                        name={CLAIM.SCALE_CASE_KEY}
                        value={get(claim, [CLAIM.SCALE_CASE_KEY])}
                        onChange={handleChange(CLAIM.SCALE_CASE_KEY)}
                      >
                        {!isEmpty(get(props.listings, 'casDeBareme', [])) &&
                          get(props.listings, 'casDeBareme', []).map(
                            (scaleCase: SagisConfig) => (
                              <MenuItem
                                value={scaleCase.ItemKey}
                                key={scaleCase.ItemKey}
                              >
                                {scaleCase.ItemDescription}
                              </MenuItem>
                            ),
                          )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    {get(claim, [CLAIM.SCALE_CASE_KEY]) && (
                      <FormControl fullWidth>
                        <InputLabel
                          ref={inputLabel}
                          id="circumstanceCode"
                          className="label"
                        >
                          {translate({ ...messages.circumstance }, props)}
                        </InputLabel>
                        <Select
                          name={CLAIM.ACCIDENT_CIRCONSTANCE_KEY}
                          value={get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY])}
                          onChange={handleChange(
                            CLAIM.ACCIDENT_CIRCONSTANCE_KEY,
                          )}
                        >
                          {!isEmpty(getCircumstances()) &&
                            getCircumstances().map(
                              (circumstance: SagisConfig) => (
                                <MenuItem
                                  value={circumstance.ItemKey}
                                  key={circumstance.ItemKey}
                                >
                                  {circumstance.ItemDescription}
                                </MenuItem>
                              ),
                            )}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  {isScaleCaseOther ||
                    (!isEmpty(claim[CLAIM.ACCIDENT_CIRCONSTANCE]) &&
                      /* istanbul ignore next */
                      get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) && (
                        /* istanbul ignore next */
                        <Grid item xs={3}>
                          <TextField
                            onChange={handleChange(CLAIM.ACCIDENT_CIRCONSTANCE)}
                            name={CLAIM.ACCIDENT_CIRCONSTANCE}
                            value={get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE])}
                            label={translate(
                              { ...messages.circumstanceDetail },
                              props,
                            )}
                            fullWidth
                            multiline
                          />
                        </Grid>
                      ))}

                  <Grid item xs={3}>
                    {get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) && (
                      <FormControl fullWidth>
                        <InputLabel
                          ref={inputLabel}
                          id="responsibility"
                          className="label"
                        >
                          {translate({ ...messages.responsibility }, props)}
                        </InputLabel>
                        <Select
                          name={CLAIM.RESPONSABILITY_KEY}
                          value={get(claim, [CLAIM.RESPONSABILITY_KEY])}
                          onChange={handleChange(CLAIM.RESPONSABILITY_KEY)}
                          disabled={!isScaleCaseOther}
                        >
                          {!isEmpty(
                            get(props.listings, 'responsability', []),
                          ) &&
                            get(props.listings, 'responsability', []).map(
                              (responsability: SagisConfig) => (
                                <MenuItem
                                  value={responsability.ItemKey}
                                  key={responsability.ItemKey}
                                >
                                  {responsability.ItemDescription}
                                </MenuItem>
                              ),
                            )}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    {get(claim, [CLAIM.RESPONSABILITY_KEY]) && (
                      <TextField
                        id="standard-basic-desc"
                        onChange={handleChange(CLAIM.ACCIDENT_DESCRIPTION)}
                        name={CLAIM.ACCIDENT_DESCRIPTION}
                        value={get(claim, [CLAIM.ACCIDENT_DESCRIPTION])}
                        label={translate({ ...messages.description }, props)}
                        fullWidth
                        InputProps={props.inputProps}
                        disabled={props.disableInput}
                        InputLabelProps={{ shrink: props.inputLabelProps }}
                        multiline
                        error={
                          !!get(props.claimCircumstancesValidation, [
                            CLAIM.ACCIDENT_DESCRIPTION,
                          ])
                        }
                        helperText={message[CLAIM.ACCIDENT_DESCRIPTION]}
                      />
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </GridWrapper>
          <div className="checkdiv">
            <Typography className="text">
              {translate({ ...messages.legalProcedure }, props)}
            </Typography>
            {!props.isRecapPage ? (
              <FormControl>
                <RadioGroup
                  value={get(claim, [CLAIM.IS_JUDICIAL_PROCEDURE], '')}
                  onChange={handleChange(CLAIM.IS_JUDICIAL_PROCEDURE)}
                  row
                >
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.YES}
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate({ ...messages.yes }, props)}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.NO}
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate({ ...messages.no }, props)}
                  />
                </RadioGroup>
                {!!get(props.claimCircumstancesValidation, [
                  CLAIM.IS_JUDICIAL_PROCEDURE,
                ]) && (
                  <FormHelperText className="error">
                    {message[CLAIM.IS_JUDICIAL_PROCEDURE]}
                  </FormHelperText>
                )}
              </FormControl>
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={true}
                    checkedIcon={<CheckCircle />}
                    icon={<RadioButtonUnchecked />}
                    disabled={props.disableInput}
                  />
                }
                label={
                  !!get(claim, [CLAIM.JUDICIAL_PROCEDURE_ID])
                    ? /* istanbul ignore next */ translate(
                        { ...messages.yes },
                        props,
                      )
                    : translate({ ...messages.no }, props)
                }
              />
            )}
          </div>
          <Collapse
            in={
              !props.isRecapPage
                ? get(claim, [CLAIM.IS_JUDICIAL_PROCEDURE], '') === CHOICE.YES
                : !!get(claim, [CLAIM.JUDICIAL_PROCEDURE_ID], '')
            }
          >
            <FormControl>
              <RadioGroup
                className="subContainer"
                aria-label="position"
                name="position"
                value={get(claim, [CLAIM.JUDICIAL_PROCEDURE_ID], '')}
                onChange={handleChange(CLAIM.JUDICIAL_PROCEDURE_ID)}
                row
              >
                {!isEmpty(get(props.listings, 'judicialProcedures', [])) &&
                  props.listings!.judicialProcedures.map(
                    (procedure: Config) => (
                      <FormControlLabel
                        key={procedure.id}
                        value={procedure.id}
                        classes={{ label: 'radio-label-style' }}
                        control={
                          <Radio
                            color="primary"
                            disabled={props.disableInput}
                          />
                        }
                        label={procedure.title}
                        labelPlacement="end"
                        className="input-checkbox"
                      />
                    ),
                  )}
              </RadioGroup>
              {!!get(props.claimCircumstancesValidation, [
                CLAIM.JUDICIAL_PROCEDURE_ID,
              ]) && (
                <FormHelperText className="error">
                  {message[CLAIM.JUDICIAL_PROCEDURE_ID]}
                </FormHelperText>
              )}
            </FormControl>
          </Collapse>
        </CardContent>
      </Card>
      <ClaimCircumstancesDrawer
        open={expandClaimCircumstancesDrawer}
        handleToggleDrawer={updateFormByProfile}
        claimToPreopen={value}
        judicialProcedures={get(props.listings, 'judicialProcedures', [])}
        setClaimRecap={props.setClaimRecap}
        closeClaimCircumstancesDrawer={closeClaimCircumstancesDrawer}
      />
    </Container>
  );
};
export default injectIntl(ClaimCircumstances);
